import {Injectable} from "@angular/core";
import {BaseService} from "../infra/base-service";
import { NovaListaContato, ListaContato, ResponseObterListasContato, DownloadResponse, ResponsePreGravacao } from "../interfaces/lista-contato/lista-contato.interface";
import { EnumTipoDownload } from "../enums/tipo-arquivo-download.enum";
import { HttpResponse } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { HttpClient } from "@angular/common/http";
@Injectable({
    providedIn: 'root'
})
export class ListasService extends BaseService {
    constructor(http: HttpClient, toastr: ToastrService) {
        super(http, toastr);
      }

    async gerarListaContato(novaListaContato: NovaListaContato) {
        return await this.post('listadecontato/salvar', novaListaContato);
    }

    async obterListasContato(quantidade: number, pagina: number): Promise<ResponseObterListasContato> {
        return await this.get<ResponseObterListasContato>(`listadecontato/listar?quantidade=${quantidade}&pagina=${pagina}`);
    }

    async downloadListaContato(idLista: number, tipoDownload: EnumTipoDownload): Promise<DownloadResponse> {
        const response = await this.getBlob<Blob>(`listadecontato/download?idLista=${idLista}&tipo=${tipoDownload}`);
        const extensao = EnumTipoDownload[tipoDownload].toString().toLowerCase();
        const fileName = `contatos_${idLista}.${extensao}`;
        return {
          blob: response.body as Blob,
          fileName
        }
    }

    async preGravacao(listaContato: NovaListaContato): Promise<ResponsePreGravacao> {
        return await this.post<ResponsePreGravacao>(`listadecontato/pregravacao`, listaContato);
    }
}
